import { h, JSX } from "preact";

import classname from "../../../foundation/utils/classname";
import IconCheck from "../Icons/IconCheck";

import styles from "./Checkbox.module.css";

type Props = Omit<JSX.HTMLAttributes<HTMLInputElement>, "type">;

function Checkbox({
    class: cssClass,
    checked,
    disabled,
    readOnly,
    style,
    ...nativeInputProps
}: Props) {
    return (
        <div
            class={classname(styles.checkboxWrapper, cssClass, {
                [styles.checked]: checked,
                [styles.disabled]: disabled,
                [styles.readOnly]: readOnly
            })}
            style={style}>
            <input
                {...nativeInputProps}
                class={styles.checkboxInput}
                type="checkbox"
                checked={checked}
                disabled={disabled || readOnly}/>
            {checked && <IconCheck/>}
        </div>
    );
}

export {
    Props as CheckboxProps
};

export default Checkbox;
